import { Button, Card, CardStackSection, Heading, Stack, Text } from '@origin-digital/ods-core';
import { IconCheckCircle } from '@origin-digital/ods-icons';
import { IUserDataAA, navigation } from '@origin-digital/reporting-client';
import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { Page } from 'ts/components/Page';

export const ChangePasswordSuccessPage: React.FC<RouteComponentProps> = ({ location }) => {
  React.useEffect(() => {
    navigation('screen', {
      currentUri: 'update-password',
      friendlyUri: 'originenergy:my-account:profile:update-password:thank-you',
      user: {
        authenticated: 'authenticated',
      } as IUserDataAA,
    });
  }, []);

  const redirectToReturnUrl = () => {
    const returnToUrl = new URLSearchParams(location.search).get('returnTo');
    window.location.assign(returnToUrl);
  };
  return (
    <Page authenticated={true}>
      <CardStackSection>
        <Card>
          <Stack space={['xlarge', 'xxlarge']} alignX="center">
            <Stack alignX="center">
              <IconCheckCircle size="medium" color="positiveLight" />
              <Heading variant="h3">All done!</Heading>
              <Text>Your password has been updated.</Text>
            </Stack>
            <Button onClick={redirectToReturnUrl} fullWidth>
              Done
            </Button>
          </Stack>
        </Card>
      </CardStackSection>
    </Page>
  );
};
